module.exports = __webpack_public_path__ + "static/media/work_on.27884fe6.png";